import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { translation } from '@cue/translations';
import { ButtonComponent } from '@cue/assist/ui/buttons';
import { cueClose, cueDelete } from '@cue/ui/icons';
import { TranslocoPipe } from '@jsverse/transloco';
import { ModalBodyComponent, ModalComponent, ModalFooterComponent, ModalHeaderComponent } from '@cue/modal';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { SubjectPipe } from '@cue/pipes';

export type CancelParticipationData = {
  reservation: any;
};
@Component({
  selector: 'cue-reservation-cancel-participation',
  templateUrl: './reservation-cancel-participation.component.html',
  styleUrls: ['./reservation-cancel-participation.component.scss'],
  imports: [
    TranslocoPipe,
    ButtonComponent,
    ModalComponent,
    ModalFooterComponent,
    ModalHeaderComponent,
    ModalBodyComponent,
    SubjectPipe,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReservationCancelParticipationComponent {
  translation = translation;
  modal = inject(DialogRef);
  modalData = inject<CancelParticipationData>(DIALOG_DATA);
  cueClose = cueClose;
  cueDelete = cueDelete;
}
